import React, { useState, useEffect } from 'react';
import styles from './Prompt.module.scss';

import ManCryingGif from '../../assets/mancrying.gif';
import ManCryingSound from '../../assets/mancrying.mp3';

function CryingManComponent() {
    const [shouldUnmount, setShouldUnmount] = useState(false);

    useEffect(() => {
        const audio = new Audio(ManCryingSound);
        audio.play().catch((error) => console.error('Audio playback error:', error));

        const duration = 3500;
        const timeoutId = setTimeout(() => {
            audio.pause();
            audio.currentTime = 0;
            setShouldUnmount(true);
        }, duration);

        return () => clearTimeout(timeoutId);
    }, []);

    return shouldUnmount ? null : <img src={ManCryingGif} alt="Man crying" className={styles.manCrying} />;
}

function Prompt({ handleResponse }) {
    const PASSWORD = '0000';
    const [showCryingMan, setShowCryingMan] = useState(false);

    function handleSubmit() {
        const input = document.querySelector('input');
        if (input.value === PASSWORD) {
            handleResponse(true);
        } else {
            setShowCryingMan(true);
            setTimeout(() => {
                setShowCryingMan(false);
            }, 2000);
            handleResponse(false);
        }
    }

    return (
        <div className={styles.wrapper}>
            <h1>
                Enter
                <br />
                Your Passcode
            </h1>
            <div className={styles.submitPass}>
                <input type="tel" pattern="[0-9]*" inputMode="numeric" placeholder="•" maxLength="6" />
                <button type="submit" onClick={handleSubmit}>
                    Log In
                </button>
            </div>
            {showCryingMan && <CryingManComponent />}
        </div>
    );
}

export default Prompt;
